<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99935 2.5L11.416 6.91667L15.8327 8.33333L11.416 9.75L9.99935 14.1667L8.58268 9.75L4.16602 8.33333L8.58268 6.91667L9.99935 2.5Z"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.8327 14.167V17.5003M14.166 15.8337H17.4993"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
